// extracted by mini-css-extract-plugin
module.exports = {"PersonalInfo":"styles_PersonalInfo__2f2qC","PersonalInfo-photo":"styles_PersonalInfo-photo__xD5dL"};